import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Banking account number is a string of 5 to 17 alphanumeric values for representing an generic account number */
  AccountNumber: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: { input: any; output: any; }
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: { input: any; output: any; }
  /** A field whose value conforms to the standard cuid format as specified in https://github.com/ericelliott/cuid#broken-down */
  Cuid: { input: any; output: any; }
  /** A field whose value is a Currency: https://en.wikipedia.org/wiki/ISO_4217. */
  Currency: { input: any; output: any; }
  /** A field whose value conforms to the standard DID format as specified in did-core: https://www.w3.org/TR/did-core/. */
  DID: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** A field whose value conforms to the standard DeweyDecimal format as specified by the OCLC https://www.oclc.org/content/dam/oclc/dewey/resources/summaries/deweysummaries.pdf */
  DeweyDecimal: { input: any; output: any; }
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  Duration: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  GUID: { input: any; output: any; }
  /** A field whose value is a CSS HSL color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSL: { input: any; output: any; }
  /** A field whose value is a CSS HSLA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSLA: { input: any; output: any; }
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: { input: any; output: any; }
  /** A field whose value is a hexadecimal: https://en.wikipedia.org/wiki/Hexadecimal. */
  Hexadecimal: { input: any; output: any; }
  /** A field whose value is an International Bank Account Number (IBAN): https://en.wikipedia.org/wiki/International_Bank_Account_Number. */
  IBAN: { input: any; output: any; }
  /** A field whose value is either an IPv4 or IPv6 address: https://en.wikipedia.org/wiki/IP_address. */
  IP: { input: any; output: any; }
  /** A field whose value is an IPC Class Symbol within the International Patent Classification System: https://www.wipo.int/classifications/ipc/en/ */
  IPCPatent: { input: any; output: any; }
  /** A field whose value is a IPv4 address: https://en.wikipedia.org/wiki/IPv4. */
  IPv4: { input: any; output: any; }
  /** A field whose value is a IPv6 address: https://en.wikipedia.org/wiki/IPv6. */
  IPv6: { input: any; output: any; }
  /** A field whose value is a ISBN-10 or ISBN-13 number: https://en.wikipedia.org/wiki/International_Standard_Book_Number. */
  ISBN: { input: any; output: any; }
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  ISO8601Duration: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: { input: any; output: any; }
  /** A field whose value conforms to the Library of Congress Subclass Format ttps://www.loc.gov/catdir/cpso/lcco/ */
  LCCSubclass: { input: any; output: any; }
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: { input: any; output: any; }
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: { input: any; output: any; }
  /** A local date-time string (i.e., with no associated timezone) in `YYYY-MM-DDTHH:mm:ss` format, e.g. `2020-01-01T00:00:00`. */
  LocalDateTime: { input: any; output: any; }
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`.  This scalar is very similar to the `LocalTime`, with the only difference being that `LocalEndTime` also allows `24:00` as a valid value to indicate midnight of the following day.  This is useful when using the scalar to represent the exclusive upper bound of a time block. */
  LocalEndTime: { input: any; output: any; }
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: { input: any; output: any; }
  /** The locale in the format of a BCP 47 (RFC 5646) standard string */
  Locale: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: { input: any; output: any; }
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: { input: any; output: any; }
  /** A field whose value is a IEEE 802 48-bit MAC address: https://en.wikipedia.org/wiki/MAC_address. */
  MAC: { input: any; output: any; }
  /** Floats that will have a value less than 0. */
  NegativeFloat: { input: any; output: any; }
  /** Integers that will have a value less than 0. */
  NegativeInt: { input: any; output: any; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: any; output: any; }
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: { input: any; output: any; }
  /** Floats that will have a value of 0 or less. */
  NonPositiveFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or less. */
  NonPositiveInt: { input: any; output: any; }
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: { input: any; output: any; }
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: { input: any; output: any; }
  /** A field whose value is a valid TCP port within the range of 0 to 65535: https://en.wikipedia.org/wiki/Transmission_Control_Protocol#TCP_ports */
  Port: { input: any; output: any; }
  /** Floats that will have a value greater than 0. */
  PositiveFloat: { input: any; output: any; }
  /** Integers that will have a value greater than 0. */
  PositiveInt: { input: any; output: any; }
  /** A field whose value conforms to the standard postal code formats for United States, United Kingdom, Germany, Canada, France, Italy, Australia, Netherlands, Spain, Denmark, Sweden, Belgium, India, Austria, Portugal, Switzerland or Luxembourg. */
  PostalCode: { input: any; output: any; }
  /** A field whose value is a CSS RGB color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGB: { input: any; output: any; }
  /** A field whose value is a CSS RGBA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGBA: { input: any; output: any; }
  /** In the US, an ABA routing transit number (`ABA RTN`) is a nine-digit code to identify the financial institution. */
  RoutingNumber: { input: any; output: any; }
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: { input: any; output: any; }
  /** A field whose value is a Semantic Version: https://semver.org */
  SemVer: { input: any; output: any; }
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: { input: any; output: any; }
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: { input: any; output: any; }
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: any; output: any; }
  /** A currency string, such as $21.25 */
  USCurrency: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any; }
  /** Floats that will have a value of 0 or more. */
  UnsignedFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or more. */
  UnsignedInt: { input: any; output: any; }
  /** A field whose value is a UTC Offset: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  UtcOffset: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export type AccessToken = {
  __typename?: 'AccessToken';
  profile: UserProfile;
  token: Scalars['String']['output'];
};

export type Administrator = {
  __typename?: 'Administrator';
  appName?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<MediaFile>;
  id?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recId: Scalars['String']['output'];
  telegram?: Maybe<Scalars['String']['output']>;
};

/** Денежный лицевой счёт клиента в AMANI. */
export type Balance = {
  __typename?: 'Balance';
  /** Деньги на балансе, BYN. */
  amount: Scalars['Float']['output'];
  /** Задолженность, BYN. */
  debt: Scalars['Float']['output'];
};

export type Branch = {
  __typename?: 'Branch';
  address?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  contractUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  googleMapsLink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  instagramLink?: Maybe<Scalars['String']['output']>;
  locationRecId?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<MediaFile>>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['Float']['output']>;
  recId: Scalars['String']['output'];
  schedule?: Maybe<Scalars['String']['output']>;
  telegramLink?: Maybe<Scalars['String']['output']>;
  whatsAppLink?: Maybe<Scalars['String']['output']>;
};

export type BranchesList = {
  __typename?: 'BranchesList';
  items: Array<Branch>;
};

export enum CacheNames {
  AllPasses = 'ALL_PASSES',
  AllUpcomingLessons = 'ALL_UPCOMING_LESSONS',
  Branches = 'BRANCHES',
  Location = 'LOCATION',
  UserProfile = 'USER_PROFILE'
}

/**
 * Заказ на оплату картой через эквайринг Альфа-Банка.
 * Оплата происходит на стороне банка: клиента нужно увести на `formUrl`.
 */
export type CardPayment = {
  __typename?: 'CardPayment';
  /** Сумма к оплате, BYN. */
  amount: Scalars['Float']['output'];
  /** Платёжная страница банка. Там же появляются Apple Pay и Samsung Pay. */
  formUrl: Scalars['String']['output'];
  /** Наш номер заказа — по нему потом подтверждается оплата. */
  orderNumber: Scalars['String']['output'];
};

export type ClubMembership = {
  __typename?: 'ClubMembership';
  active: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['Date']['output']>;
};

export type CourseEnrollment = {
  __typename?: 'CourseEnrollment';
  /** Списано с денежного баланса, BYN. */
  paidFromBalance: Scalars['Float']['output'];
  /** Закрыто бонусами, BYN. */
  paidWithBonus: Scalars['Float']['output'];
  serviceRecId: Scalars['String']['output'];
};

/**
 * МК или онлайн-курс, доступный для самостоятельной записи из приложения.
 * Цена и лимит бонусов берутся из «⚙️ Типы услуг», лимит мест — из конфига.
 */
export type CourseOffer = {
  __typename?: 'CourseOffer';
  /** Денежный баланс клиента — чтобы показать «записаться» или «пополнить». */
  balance: Scalars['Float']['output'];
  /** Сколько BYN реально спишется бонусами, если включить оплату бонусами. */
  bonusAvailable: Scalars['Float']['output'];
  /** Макс. доля цены, оплачиваемая бонусами (0..1). 0 — бонусами платить нельзя. */
  bonusRatio: Scalars['Float']['output'];
  /**
   * Доступна ли оплата картой. `false` — эквайринг Альфы не настроен, показывать
   * кнопку карты нельзя, остаётся ЕРИП.
   */
  cardPaymentAvailable: Scalars['Boolean']['output'];
  currency: Scalars['String']['output'];
  /** Записан ли уже текущий клиент. */
  enrolled: Scalars['Boolean']['output'];
  /** Есть ли отложенная заявка на этот курс (авто-запись после пополнения). */
  pendingEnrollment: Scalars['Boolean']['output'];
  /** Свободных мест сейчас. */
  placesLeft: Scalars['Int']['output'];
  /** Всего мест на поток. */
  placesTotal: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  typeRecId: Scalars['String']['output'];
};

export type CreateReviewInput = {
  branch?: InputMaybe<Scalars['String']['input']>;
  dateReview?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Source>;
};

/** Банковское приложение, из которого можно оплатить счёт в ЕРИП. */
export type EripBank = {
  __typename?: 'EripBank';
  androidUrl?: Maybe<Scalars['String']['output']>;
  /** Отдельная ссылка для устройств Huawei без Google-сервисов. */
  huaweiUrl?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  iosUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/**
 * Личный счёт клиента в ЕРИП для самостоятельного пополнения баланса.
 * Постоянное платёжное требование: платить можно любую сумму, сколько угодно раз.
 */
export type EripTopUp = {
  __typename?: 'EripTopUp';
  /** Номер лицевого счёта, который клиент вводит в банке (например «4932»). */
  accountNumber: Scalars['String']['output'];
  banks: Array<EripBank>;
  /** Полный номер счёта для оплаты: «24106-1-4932». */
  fullAccountNumber: Scalars['String']['output'];
  /** Путь до услуги в дереве ЕРИП, по шагам. */
  instruction: Array<Scalars['String']['output']>;
  /** QR-код для оплаты из банковского приложения, data:image/png;base64. */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Код услуги ЕРИП (например «24106-1»). */
  serviceCode: Scalars['String']['output'];
};

export type Group = {
  __typename?: 'Group';
  archived: Scalars['Boolean']['output'];
  autoBookingPassesRecIds: Array<Scalars['String']['output']>;
  branch?: Maybe<Branch>;
  branchRecId?: Maybe<Scalars['ID']['output']>;
  dayOfWeeks: Array<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  durationHours: Scalars['Float']['output'];
  id?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  maxSeats: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  recId: Scalars['String']['output'];
  startTimeSeconds: Scalars['Int']['output'];
  teacher?: Maybe<Teacher>;
  teacherRecId?: Maybe<Scalars['ID']['output']>;
  upcomingLessons?: Maybe<Array<Lesson>>;
};

export type Lesson = {
  __typename?: 'Lesson';
  administrator?: Maybe<Administrator>;
  administratorRecId?: Maybe<Scalars['String']['output']>;
  bookingAllowed: Scalars['Boolean']['output'];
  bookingsRecIds: Array<Scalars['String']['output']>;
  /**
   * Направление этого конкретного занятия — обычно равно направлению группы,
   * но если на карточке занятия вручную заполнено поле-замена (например,
   * преподавателя заменили на ведущего другого направления), берётся оно.
   */
  direction?: Maybe<Scalars['String']['output']>;
  directionOverride?: Maybe<Scalars['String']['output']>;
  durationHours: Scalars['Float']['output'];
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  group?: Maybe<Group>;
  groupRecId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxSeats: Scalars['Int']['output'];
  noWriteOffRecIds: Array<Scalars['String']['output']>;
  passed: Scalars['Boolean']['output'];
  penaltiesRecIds: Array<Scalars['String']['output']>;
  recId: Scalars['String']['output'];
  remainingSeats: Scalars['Int']['output'];
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  teacher?: Maybe<Teacher>;
  teacherRecId?: Maybe<Scalars['String']['output']>;
  trialBookingAllowed: Scalars['Boolean']['output'];
  trialRemainingSeats: Scalars['Int']['output'];
  type?: Maybe<LessonType>;
  visitsRecIds: Array<Scalars['String']['output']>;
  waitingListRecIds: Array<Scalars['String']['output']>;
};

export enum LessonType {
  Trial = 'TRIAL'
}

export type LessonsList = {
  __typename?: 'LessonsList';
  groups: Array<Group>;
  lessons: Array<Lesson>;
  teachers: Array<Teacher>;
};

export type Links = {
  __typename?: 'Links';
  id: Scalars['String']['output'];
  recId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  lessonsRules?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recId: Scalars['String']['output'];
  schoolRules?: Maybe<Scalars['String']['output']>;
};

export type MediaFile = {
  __typename?: 'MediaFile';
  height?: Maybe<Scalars['Int']['output']>;
  recId?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: MediaFileType;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export enum MediaFileType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type Mutation = {
  __typename?: 'Mutation';
  addUserToWaitingList: Lesson;
  /** Отменить отложенную заявку на запись. */
  cancelCourseEnrollment: Scalars['Boolean']['output'];
  cancelLessonBooking: Lesson;
  /**
   * Перепроверить у банка, оплачен ли заказ, и провести оплату, если да.
   * Вызывается при возврате клиента с платёжной страницы, чтобы не ждать
   * фоновой сверки. Возвращает `true`, если деньги списаны.
   */
  confirmCardPayment: Scalars['Boolean']['output'];
  /**
   * Завести заказ на оплату МК/курса картой через Альфу и вернуть ссылку на
   * платёжную страницу банка. Как и у ЕРИП-счёта, заявка сохраняется здесь же —
   * клиент будет записан, когда оплата подтвердится.
   */
  courseCardPayment: CardPayment;
  /**
   * Выпустить разовый ЕРИП-счёт на цену МК/курса с уже зашитой суммой — QR и
   * ссылки банков открываются с подставленной суммой, вводить руками не нужно.
   * Заодно сохраняет заявку: вебхук запишет клиента после оплаты.
   */
  courseEripBill: EripTopUp;
  createLessonBooking: Lesson;
  createReview: Review;
  markLessonVisit: Lesson;
  noop?: Maybe<Scalars['Boolean']['output']>;
  removeUserFromWaitingList: Lesson;
  /**
   * Отложенная запись: сохранить намерение, чтобы система авто-записала клиента
   * после того как пополнение через ЕРИП дойдёт до баланса.
   */
  requestCourseEnrollment: Scalars['Boolean']['output'];
  sendVerificationCode?: Maybe<Scalars['Void']['output']>;
  signIn: AccessToken;
  signUp: AccessToken;
  updatePassStatusConfirmationVisit: Pass;
  updateProfile: UserProfile;
};


export type MutationAddUserToWaitingListArgs = {
  lessonRecId: Scalars['String']['input'];
  passRecId: Scalars['String']['input'];
};


export type MutationCancelLessonBookingArgs = {
  lessonRecId: Scalars['String']['input'];
  passRecId: Scalars['String']['input'];
};


export type MutationConfirmCardPaymentArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationCourseCardPaymentArgs = {
  typeRecId: Scalars['String']['input'];
  useBonus?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCourseEripBillArgs = {
  typeRecId: Scalars['String']['input'];
  useBonus?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateLessonBookingArgs = {
  lessonRecId: Scalars['String']['input'];
  passRecId: Scalars['String']['input'];
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


export type MutationMarkLessonVisitArgs = {
  fieldName: Scalars['String']['input'];
  lessonRecId: Scalars['String']['input'];
  passRecId: Scalars['String']['input'];
};


export type MutationRemoveUserFromWaitingListArgs = {
  lessonRecId: Scalars['String']['input'];
  passRecId: Scalars['String']['input'];
};


export type MutationRequestCourseEnrollmentArgs = {
  typeRecId: Scalars['String']['input'];
  useBonus?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSendVerificationCodeArgs = {
  locationId: Scalars['String']['input'];
  phone: Scalars['PhoneNumber']['input'];
  signInAs: Scalars['Boolean']['input'];
};


export type MutationSignInArgs = {
  code: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  phone: Scalars['PhoneNumber']['input'];
};


export type MutationSignUpArgs = {
  code: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  locationRecId: Scalars['String']['input'];
  name: Scalars['NonEmptyString']['input'];
  phone: Scalars['PhoneNumber']['input'];
  surname: Scalars['NonEmptyString']['input'];
  utmSource?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePassStatusConfirmationVisitArgs = {
  recId: Scalars['String']['input'];
  status: PassConfirmationVisit;
};


export type MutationUpdateProfileArgs = {
  birthday?: InputMaybe<Scalars['Date']['input']>;
};

export type Pass = {
  __typename?: 'Pass';
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  active: Scalars['Boolean']['output'];
  autoBookingGroup?: Maybe<Group>;
  autoBookingGroupRecId?: Maybe<Scalars['String']['output']>;
  branchRecId?: Maybe<Scalars['String']['output']>;
  deactivationDate?: Maybe<Scalars['DateTime']['output']>;
  freezes: Array<PassFreeze>;
  freezesRecIds: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<PassKind>;
  kindRecId?: Maybe<Scalars['String']['output']>;
  lessonsType: PassLessonsType;
  penaltiedLessons: Array<Lesson>;
  penaltiedLessonsRecIds: Array<Scalars['String']['output']>;
  recId: Scalars['String']['output'];
  refund?: Maybe<PassRefund>;
  refundRecId?: Maybe<Scalars['String']['output']>;
  remainingBookingHours: Scalars['Int']['output'];
  remainingVisitHours: Scalars['Int']['output'];
  sickLists: Array<PassSickList>;
  sickListsRecIds: Array<Scalars['String']['output']>;
  status: PassStatus;
  statusConfirmationVisit?: Maybe<PassConfirmationVisit>;
  upcomingLessons?: Maybe<Array<Lesson>>;
  userId?: Maybe<Scalars['String']['output']>;
  visitedLessons: Array<Lesson>;
  visitedLessonsRecIds: Array<Scalars['String']['output']>;
};

export enum PassCategory {
  Package = 'PACKAGE',
  Single = 'SINGLE',
  Standart = 'STANDART',
  Technical = 'TECHNICAL',
  Trial = 'TRIAL',
  Unlimited = 'UNLIMITED'
}

export enum PassConfirmationVisit {
  Confirmed = 'CONFIRMED',
  NotComing = 'NOT_COMING',
  NotSure = 'NOT_SURE'
}

export type PassFreeze = {
  __typename?: 'PassFreeze';
  daysCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  recId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type PassKind = {
  __typename?: 'PassKind';
  branchRecIds: Array<Scalars['String']['output']>;
  category: PassCategory;
  currency?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  recId: Scalars['String']['output'];
};

export enum PassLessonsType {
  Group = 'Group',
  Private = 'Private'
}

export type PassRefund = {
  __typename?: 'PassRefund';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  recId: Scalars['String']['output'];
};

export type PassResponse = {
  __typename?: 'PassResponse';
  groups: Array<Group>;
  pass: Pass;
  teachers: Array<Teacher>;
};

export type PassSickList = {
  __typename?: 'PassSickList';
  daysCount?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  recId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
};

export enum PassStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Frozen = 'FROZEN',
  NotActive = 'NOT_ACTIVE',
  NoHours = 'NO_HOURS',
  Refunded = 'REFUNDED'
}

export type PassesList = {
  __typename?: 'PassesList';
  items: Array<Pass>;
};

export type Query = {
  __typename?: 'Query';
  administrator: Administrator;
  allPasses: PassesList;
  allUpcomingLessons: LessonsList;
  balance: Balance;
  branches: BranchesList;
  clubMembership: ClubMembership;
  courseOffer: CourseOffer;
  eripTopUp: EripTopUp;
  group: Group;
  lesson: Lesson;
  link: Links;
  location: Location;
  noop?: Maybe<Scalars['Boolean']['output']>;
  pass: PassResponse;
  pastUserLessons: LessonsList;
  profile: UserProfile;
  review: Review;
  reviews: Array<Review>;
  teacher: Teacher;
  userExists: UserExistsResponse;
  yearInReviewStats: YearInReviewStats;
};


export type QueryAdministratorArgs = {
  recId: Scalars['String']['input'];
};


export type QueryAllUpcomingLessonsArgs = {
  locationId: Scalars['String']['input'];
};


export type QueryBranchesArgs = {
  locationId: Scalars['String']['input'];
};


export type QueryCourseOfferArgs = {
  typeRecId: Scalars['String']['input'];
};


export type QueryGroupArgs = {
  recId: Scalars['String']['input'];
};


export type QueryLessonArgs = {
  recId: Scalars['String']['input'];
};


export type QueryLinkArgs = {
  id: Scalars['String']['input'];
};


export type QueryLocationArgs = {
  recId: Scalars['String']['input'];
};


export type QueryPassArgs = {
  recId: Scalars['String']['input'];
};


export type QueryPastUserLessonsArgs = {
  offset: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};


export type QueryReviewArgs = {
  recId: Scalars['String']['input'];
};


export type QueryTeacherArgs = {
  recId: Scalars['String']['input'];
};


export type QueryUserExistsArgs = {
  locationId: Scalars['String']['input'];
  phone: Scalars['PhoneNumber']['input'];
};

export type Review = {
  __typename?: 'Review';
  branch?: Maybe<Scalars['String']['output']>;
  dateReview?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recId: Scalars['String']['output'];
  review?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Source>;
};

export enum Source {
  App = 'APP',
  Sticker = 'STICKER',
  Tally = 'TALLY',
  Toweco = 'TOWECO'
}

export type Teacher = {
  __typename?: 'Teacher';
  activeGroups?: Maybe<Array<Group>>;
  appName?: Maybe<Scalars['String']['output']>;
  appTitle?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  avatar?: Maybe<MediaFile>;
  branch?: Maybe<Branch>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  media: Array<MediaFile>;
  recId: Scalars['String']['output'];
  upcomingLessons?: Maybe<Array<Lesson>>;
  videosIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type UpdateLessonFields = {
  __typename?: 'UpdateLessonFields';
  noWriteOffRecIds?: Maybe<Array<Scalars['String']['output']>>;
  recId: Scalars['String']['output'];
  visitsRecIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type UserExistsResponse = {
  __typename?: 'UserExistsResponse';
  exists: Scalars['Boolean']['output'];
  selfSignUpAllowed: Scalars['Boolean']['output'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  administrator?: Maybe<Administrator>;
  birthday?: Maybe<Scalars['Date']['output']>;
  bonusBalance: Scalars['Float']['output'];
  dateLastVisit?: Maybe<Scalars['Date']['output']>;
  dateRecognition?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  recId: Scalars['String']['output'];
  surname?: Maybe<Scalars['String']['output']>;
  totalSpent: Scalars['Float']['output'];
  utmSource?: Maybe<Scalars['String']['output']>;
};

export type YearInReviewStats = {
  __typename?: 'YearInReviewStats';
  busiestMonth?: Maybe<Scalars['String']['output']>;
  busiestMonthCount?: Maybe<Scalars['Int']['output']>;
  busiestMonthHours?: Maybe<Scalars['Float']['output']>;
  favoriteAdministrator?: Maybe<Administrator>;
  favoriteAdministratorCount?: Maybe<Scalars['Int']['output']>;
  favoriteDirection?: Maybe<Scalars['String']['output']>;
  favoriteDirectionCount?: Maybe<Scalars['Int']['output']>;
  favoriteTeacher?: Maybe<Teacher>;
  favoriteTeacherCount?: Maybe<Scalars['Int']['output']>;
  totalHours: Scalars['Float']['output'];
  totalLessons: Scalars['Int']['output'];
};

export type InitialDataQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  locationRecId: Scalars['String']['input'];
}>;


export type InitialDataQuery = { __typename?: 'Query', allUpcomingLessons: { __typename?: 'LessonsList', lessons: Array<{ __typename?: 'Lesson', bookingsRecIds: Array<string>, waitingListRecIds: Array<string>, direction?: string | null, durationHours: number, endDateTime?: any | null, groupRecId?: string | null, id?: string | null, maxSeats: number, penaltiesRecIds: Array<string>, recId: string, remainingSeats: number, trialRemainingSeats: number, startDateTime?: any | null, teacherRecId?: string | null, visitsRecIds: Array<string>, noWriteOffRecIds: Array<string>, passed: boolean, type?: LessonType | null, bookingAllowed: boolean, trialBookingAllowed: boolean }>, groups: Array<{ __typename?: 'Group', archived: boolean, autoBookingPassesRecIds: Array<string>, description?: string | null, id?: string | null, maxSeats: number, name?: string | null, recId: string, teacherRecId?: string | null, branchRecId?: string | null, direction?: string | null, level?: string | null, durationHours: number, startTimeSeconds: number, dayOfWeeks: Array<number> }>, teachers: Array<{ __typename?: 'Teacher', appName?: string | null, appTitle?: string | null, description?: string | null, id?: string | null, recId: string, archived: boolean, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null, media: Array<{ __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null }> }> }, branches: { __typename?: 'BranchesList', items: Array<{ __typename?: 'Branch', address?: string | null, archived: boolean, contractUrl?: string | null, description?: string | null, googleMapsLink?: string | null, id?: string | null, locationRecId?: string | null, name?: string | null, phone?: number | null, recId: string, schedule?: string | null, instagramLink?: string | null, telegramLink?: string | null, whatsAppLink?: string | null, media?: Array<{ __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null }> | null }> }, location: { __typename?: 'Location', lessonsRules?: string | null, schoolRules?: string | null, name?: string | null, recId: string } };

export type AuthDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthDataQuery = { __typename?: 'Query', profile: { __typename?: 'UserProfile', recId: string, id: string, name?: string | null, surname?: string | null, phone?: any | null, birthday?: any | null, dateRecognition?: any | null, dateLastVisit?: any | null, utmSource?: string | null, bonusBalance: number, totalSpent: number, administrator?: { __typename?: 'Administrator', recId: string, appName?: string | null, phone?: string | null, telegram?: string | null, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null } | null }, allPasses: { __typename?: 'PassesList', items: Array<{ __typename?: 'Pass', activationDate?: any | null, active: boolean, autoBookingGroupRecId?: string | null, deactivationDate?: any | null, freezesRecIds: Array<string>, id?: string | null, kindRecId?: string | null, lessonsType: PassLessonsType, penaltiedLessonsRecIds: Array<string>, recId: string, refundRecId?: string | null, remainingBookingHours: number, remainingVisitHours: number, sickListsRecIds: Array<string>, status: PassStatus, statusConfirmationVisit?: PassConfirmationVisit | null, userId?: string | null, visitedLessonsRecIds: Array<string>, branchRecId?: string | null, kind?: { __typename?: 'PassKind', currency?: string | null, hours?: number | null, id?: string | null, name?: string | null, price?: number | null, recId: string, branchRecIds: Array<string>, category: PassCategory } | null }> }, clubMembership: { __typename?: 'ClubMembership', active: boolean, expiresAt?: any | null } };

export type UserExistsQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  phone: Scalars['PhoneNumber']['input'];
}>;


export type UserExistsQuery = { __typename?: 'Query', userExists: { __typename?: 'UserExistsResponse', exists: boolean, selfSignUpAllowed: boolean } };

export type SendVerificationCodeMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  phone: Scalars['PhoneNumber']['input'];
  signInAs: Scalars['Boolean']['input'];
}>;


export type SendVerificationCodeMutation = { __typename?: 'Mutation', sendVerificationCode?: any | null };

export type SignUpMutationVariables = Exact<{
  code: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  locationRecId: Scalars['String']['input'];
  name: Scalars['NonEmptyString']['input'];
  phone: Scalars['PhoneNumber']['input'];
  surname: Scalars['NonEmptyString']['input'];
  utmSource?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignUpMutation = { __typename?: 'Mutation', auth: { __typename?: 'AccessToken', token: string, profile: { __typename?: 'UserProfile', recId: string, id: string, name?: string | null, surname?: string | null, phone?: any | null, birthday?: any | null, dateRecognition?: any | null, dateLastVisit?: any | null, utmSource?: string | null, bonusBalance: number, totalSpent: number, administrator?: { __typename?: 'Administrator', recId: string, appName?: string | null, phone?: string | null, telegram?: string | null, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null } | null } } };

export type SignInMutationVariables = Exact<{
  code: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  phone: Scalars['PhoneNumber']['input'];
}>;


export type SignInMutation = { __typename?: 'Mutation', auth: { __typename?: 'AccessToken', token: string, profile: { __typename?: 'UserProfile', recId: string, id: string, name?: string | null, surname?: string | null, phone?: any | null, birthday?: any | null, dateRecognition?: any | null, dateLastVisit?: any | null, utmSource?: string | null, bonusBalance: number, totalSpent: number, administrator?: { __typename?: 'Administrator', recId: string, appName?: string | null, phone?: string | null, telegram?: string | null, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null } | null } } };

export type BalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type BalanceQuery = { __typename?: 'Query', balance: { __typename?: 'Balance', amount: number, debt: number } };

export type EripTopUpQueryVariables = Exact<{ [key: string]: never; }>;


export type EripTopUpQuery = { __typename?: 'Query', eripTopUp: { __typename?: 'EripTopUp', accountNumber: string, serviceCode: string, fullAccountNumber: string, qrCode?: string | null, instruction: Array<string>, banks: Array<{ __typename?: 'EripBank', name: string, icon?: string | null, iosUrl?: string | null, androidUrl?: string | null, huaweiUrl?: string | null }> } };

export type CourseOfferQueryVariables = Exact<{
  typeRecId: Scalars['String']['input'];
}>;


export type CourseOfferQuery = { __typename?: 'Query', courseOffer: { __typename?: 'CourseOffer', typeRecId: string, title: string, price: number, currency: string, placesLeft: number, placesTotal: number, bonusRatio: number, bonusAvailable: number, enrolled: boolean, balance: number, pendingEnrollment: boolean } };

export type RequestCourseEnrollmentMutationVariables = Exact<{
  typeRecId: Scalars['String']['input'];
  useBonus: Scalars['Boolean']['input'];
}>;


export type RequestCourseEnrollmentMutation = { __typename?: 'Mutation', requestCourseEnrollment: boolean };

export type CourseEripBillMutationVariables = Exact<{
  typeRecId: Scalars['String']['input'];
  useBonus: Scalars['Boolean']['input'];
}>;


export type CourseEripBillMutation = { __typename?: 'Mutation', courseEripBill: { __typename?: 'EripTopUp', fullAccountNumber: string, qrCode?: string | null, banks: Array<{ __typename?: 'EripBank', name: string, icon?: string | null, iosUrl?: string | null, androidUrl?: string | null, huaweiUrl?: string | null }> } };

export type GroupQueryVariables = Exact<{
  recId: Scalars['String']['input'];
  hasCached: Scalars['Boolean']['input'];
}>;


export type GroupQuery = { __typename?: 'Query', group?: { __typename?: 'Group', archived: boolean, autoBookingPassesRecIds: Array<string>, description?: string | null, id?: string | null, maxSeats: number, name?: string | null, recId: string, teacherRecId?: string | null, branchRecId?: string | null, direction?: string | null, level?: string | null, durationHours: number, startTimeSeconds: number, dayOfWeeks: Array<number>, teacher?: { __typename?: 'Teacher', appName?: string | null, appTitle?: string | null, description?: string | null, id?: string | null, recId: string, archived: boolean, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null, media: Array<{ __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null }> } | null, branch?: { __typename?: 'Branch', address?: string | null, archived: boolean, contractUrl?: string | null, description?: string | null, googleMapsLink?: string | null, id?: string | null, locationRecId?: string | null, name?: string | null, phone?: number | null, recId: string, schedule?: string | null, instagramLink?: string | null, telegramLink?: string | null, whatsAppLink?: string | null, media?: Array<{ __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null }> | null } | null } };

export type LessonQueryVariables = Exact<{
  recId: Scalars['String']['input'];
  hasCached: Scalars['Boolean']['input'];
}>;


export type LessonQuery = { __typename?: 'Query', lesson?: { __typename?: 'Lesson', bookingsRecIds: Array<string>, waitingListRecIds: Array<string>, direction?: string | null, durationHours: number, endDateTime?: any | null, groupRecId?: string | null, id?: string | null, maxSeats: number, penaltiesRecIds: Array<string>, recId: string, remainingSeats: number, trialRemainingSeats: number, startDateTime?: any | null, teacherRecId?: string | null, visitsRecIds: Array<string>, noWriteOffRecIds: Array<string>, passed: boolean, type?: LessonType | null, bookingAllowed: boolean, trialBookingAllowed: boolean, group?: { __typename?: 'Group', archived: boolean, autoBookingPassesRecIds: Array<string>, description?: string | null, id?: string | null, maxSeats: number, name?: string | null, recId: string, teacherRecId?: string | null, branchRecId?: string | null, direction?: string | null, level?: string | null, durationHours: number, startTimeSeconds: number, dayOfWeeks: Array<number> } | null, teacher?: { __typename?: 'Teacher', appName?: string | null, appTitle?: string | null, description?: string | null, id?: string | null, recId: string, archived: boolean, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null, media: Array<{ __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null }> } | null } };

export type CancelLessonMutationVariables = Exact<{
  lessonRecId: Scalars['String']['input'];
  passRecId: Scalars['String']['input'];
}>;


export type CancelLessonMutation = { __typename?: 'Mutation', cancelLessonBooking: { __typename?: 'Lesson', bookingsRecIds: Array<string>, waitingListRecIds: Array<string>, direction?: string | null, durationHours: number, endDateTime?: any | null, groupRecId?: string | null, id?: string | null, maxSeats: number, penaltiesRecIds: Array<string>, recId: string, remainingSeats: number, trialRemainingSeats: number, startDateTime?: any | null, teacherRecId?: string | null, visitsRecIds: Array<string>, noWriteOffRecIds: Array<string>, passed: boolean, type?: LessonType | null, bookingAllowed: boolean, trialBookingAllowed: boolean } };

export type BookLessonMutationVariables = Exact<{
  lessonRecId: Scalars['String']['input'];
  passRecId: Scalars['String']['input'];
}>;


export type BookLessonMutation = { __typename?: 'Mutation', createLessonBooking: { __typename?: 'Lesson', bookingsRecIds: Array<string>, waitingListRecIds: Array<string>, direction?: string | null, durationHours: number, endDateTime?: any | null, groupRecId?: string | null, id?: string | null, maxSeats: number, penaltiesRecIds: Array<string>, recId: string, remainingSeats: number, trialRemainingSeats: number, startDateTime?: any | null, teacherRecId?: string | null, visitsRecIds: Array<string>, noWriteOffRecIds: Array<string>, passed: boolean, type?: LessonType | null, bookingAllowed: boolean, trialBookingAllowed: boolean } };

export type AddUserToWaitingListMutationVariables = Exact<{
  lessonRecId: Scalars['String']['input'];
  waitingListPassRecId: Scalars['String']['input'];
}>;


export type AddUserToWaitingListMutation = { __typename?: 'Mutation', addUserToWaitingList: { __typename?: 'Lesson', bookingsRecIds: Array<string>, waitingListRecIds: Array<string>, direction?: string | null, durationHours: number, endDateTime?: any | null, groupRecId?: string | null, id?: string | null, maxSeats: number, penaltiesRecIds: Array<string>, recId: string, remainingSeats: number, trialRemainingSeats: number, startDateTime?: any | null, teacherRecId?: string | null, visitsRecIds: Array<string>, noWriteOffRecIds: Array<string>, passed: boolean, type?: LessonType | null, bookingAllowed: boolean, trialBookingAllowed: boolean } };

export type RemoveUserFromWaitingListMutationVariables = Exact<{
  lessonRecId: Scalars['String']['input'];
  waitingListPassRecId: Scalars['String']['input'];
}>;


export type RemoveUserFromWaitingListMutation = { __typename?: 'Mutation', removeUserFromWaitingList: { __typename?: 'Lesson', bookingsRecIds: Array<string>, waitingListRecIds: Array<string>, direction?: string | null, durationHours: number, endDateTime?: any | null, groupRecId?: string | null, id?: string | null, maxSeats: number, penaltiesRecIds: Array<string>, recId: string, remainingSeats: number, trialRemainingSeats: number, startDateTime?: any | null, teacherRecId?: string | null, visitsRecIds: Array<string>, noWriteOffRecIds: Array<string>, passed: boolean, type?: LessonType | null, bookingAllowed: boolean, trialBookingAllowed: boolean } };

export type PastLessonsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type PastLessonsQuery = { __typename?: 'Query', pastUserLessons: { __typename?: 'LessonsList', groups: Array<{ __typename?: 'Group', archived: boolean, autoBookingPassesRecIds: Array<string>, description?: string | null, id?: string | null, maxSeats: number, name?: string | null, recId: string, teacherRecId?: string | null, branchRecId?: string | null, direction?: string | null, level?: string | null, durationHours: number, startTimeSeconds: number, dayOfWeeks: Array<number> }>, lessons: Array<{ __typename?: 'Lesson', bookingsRecIds: Array<string>, waitingListRecIds: Array<string>, direction?: string | null, durationHours: number, endDateTime?: any | null, groupRecId?: string | null, id?: string | null, maxSeats: number, penaltiesRecIds: Array<string>, recId: string, remainingSeats: number, trialRemainingSeats: number, startDateTime?: any | null, teacherRecId?: string | null, visitsRecIds: Array<string>, noWriteOffRecIds: Array<string>, passed: boolean, type?: LessonType | null, bookingAllowed: boolean, trialBookingAllowed: boolean }>, teachers: Array<{ __typename?: 'Teacher', appName?: string | null, appTitle?: string | null, description?: string | null, id?: string | null, recId: string, archived: boolean, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null, media: Array<{ __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null }> }> } };

export type PassQueryVariables = Exact<{
  recId: Scalars['String']['input'];
}>;


export type PassQuery = { __typename?: 'Query', pass: { __typename?: 'PassResponse', groups: Array<{ __typename?: 'Group', archived: boolean, autoBookingPassesRecIds: Array<string>, description?: string | null, id?: string | null, maxSeats: number, name?: string | null, recId: string, teacherRecId?: string | null, branchRecId?: string | null, direction?: string | null, level?: string | null, durationHours: number, startTimeSeconds: number, dayOfWeeks: Array<number> }>, pass: { __typename?: 'Pass', activationDate?: any | null, active: boolean, autoBookingGroupRecId?: string | null, deactivationDate?: any | null, freezesRecIds: Array<string>, id?: string | null, kindRecId?: string | null, lessonsType: PassLessonsType, penaltiedLessonsRecIds: Array<string>, recId: string, refundRecId?: string | null, remainingBookingHours: number, remainingVisitHours: number, sickListsRecIds: Array<string>, status: PassStatus, statusConfirmationVisit?: PassConfirmationVisit | null, userId?: string | null, visitedLessonsRecIds: Array<string>, branchRecId?: string | null, autoBookingGroup?: { __typename?: 'Group', archived: boolean, autoBookingPassesRecIds: Array<string>, description?: string | null, id?: string | null, maxSeats: number, name?: string | null, recId: string, teacherRecId?: string | null, branchRecId?: string | null, direction?: string | null, level?: string | null, durationHours: number, startTimeSeconds: number, dayOfWeeks: Array<number> } | null, penaltiedLessons: Array<{ __typename?: 'Lesson', bookingsRecIds: Array<string>, waitingListRecIds: Array<string>, direction?: string | null, durationHours: number, endDateTime?: any | null, groupRecId?: string | null, id?: string | null, maxSeats: number, penaltiesRecIds: Array<string>, recId: string, remainingSeats: number, trialRemainingSeats: number, startDateTime?: any | null, teacherRecId?: string | null, visitsRecIds: Array<string>, noWriteOffRecIds: Array<string>, passed: boolean, type?: LessonType | null, bookingAllowed: boolean, trialBookingAllowed: boolean }>, visitedLessons: Array<{ __typename?: 'Lesson', bookingsRecIds: Array<string>, waitingListRecIds: Array<string>, direction?: string | null, durationHours: number, endDateTime?: any | null, groupRecId?: string | null, id?: string | null, maxSeats: number, penaltiesRecIds: Array<string>, recId: string, remainingSeats: number, trialRemainingSeats: number, startDateTime?: any | null, teacherRecId?: string | null, visitsRecIds: Array<string>, noWriteOffRecIds: Array<string>, passed: boolean, type?: LessonType | null, bookingAllowed: boolean, trialBookingAllowed: boolean }>, freezes: Array<{ __typename?: 'PassFreeze', daysCount?: number | null, id?: string | null, price?: number | null, recId: string, startDate?: any | null }>, refund?: { __typename?: 'PassRefund', amount?: number | null, date?: any | null, id?: string | null, recId: string } | null, sickLists: Array<{ __typename?: 'PassSickList', daysCount?: number | null, endDate?: any | null, id?: string | null, photo?: string | null, recId: string, startDate?: any | null }>, kind?: { __typename?: 'PassKind', currency?: string | null, hours?: number | null, id?: string | null, name?: string | null, price?: number | null, recId: string, branchRecIds: Array<string>, category: PassCategory } | null }, teachers: Array<{ __typename?: 'Teacher', appName?: string | null, appTitle?: string | null, description?: string | null, id?: string | null, recId: string, archived: boolean, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null, media: Array<{ __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null }> }> } };

export type UpdateProfileMutationVariables = Exact<{
  birthday?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'UserProfile', recId: string, id: string, name?: string | null, surname?: string | null, phone?: any | null, birthday?: any | null, dateRecognition?: any | null, dateLastVisit?: any | null, utmSource?: string | null, bonusBalance: number, totalSpent: number, administrator?: { __typename?: 'Administrator', recId: string, appName?: string | null, phone?: string | null, telegram?: string | null, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null } | null } };

export type TeacherQueryVariables = Exact<{
  recId: Scalars['String']['input'];
  hasCached: Scalars['Boolean']['input'];
}>;


export type TeacherQuery = { __typename?: 'Query', teacher?: { __typename?: 'Teacher', appName?: string | null, appTitle?: string | null, description?: string | null, id?: string | null, recId: string, archived: boolean, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null, media: Array<{ __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null }> } };

export type YearInReviewStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type YearInReviewStatsQuery = { __typename?: 'Query', yearInReviewStats: { __typename?: 'YearInReviewStats', totalLessons: number, totalHours: number, busiestMonth?: string | null, busiestMonthCount?: number | null, busiestMonthHours?: number | null, favoriteDirection?: string | null, favoriteDirectionCount?: number | null, favoriteTeacherCount?: number | null, favoriteAdministratorCount?: number | null, favoriteTeacher?: { __typename?: 'Teacher', appName?: string | null, appTitle?: string | null, description?: string | null, id?: string | null, recId: string, archived: boolean, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null, media: Array<{ __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null }> } | null, favoriteAdministrator?: { __typename?: 'Administrator', recId: string, appName?: string | null, phone?: string | null, telegram?: string | null, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null } | null } };

export type MediaFileFragment = { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null };

export type GroupFragment = { __typename?: 'Group', archived: boolean, autoBookingPassesRecIds: Array<string>, description?: string | null, id?: string | null, maxSeats: number, name?: string | null, recId: string, teacherRecId?: string | null, branchRecId?: string | null, direction?: string | null, level?: string | null, durationHours: number, startTimeSeconds: number, dayOfWeeks: Array<number> };

export type TeacherFragment = { __typename?: 'Teacher', appName?: string | null, appTitle?: string | null, description?: string | null, id?: string | null, recId: string, archived: boolean, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null, media: Array<{ __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null }> };

export type LessonFragment = { __typename?: 'Lesson', bookingsRecIds: Array<string>, waitingListRecIds: Array<string>, direction?: string | null, durationHours: number, endDateTime?: any | null, groupRecId?: string | null, id?: string | null, maxSeats: number, penaltiesRecIds: Array<string>, recId: string, remainingSeats: number, trialRemainingSeats: number, startDateTime?: any | null, teacherRecId?: string | null, visitsRecIds: Array<string>, noWriteOffRecIds: Array<string>, passed: boolean, type?: LessonType | null, bookingAllowed: boolean, trialBookingAllowed: boolean };

export type BranchFragment = { __typename?: 'Branch', address?: string | null, archived: boolean, contractUrl?: string | null, description?: string | null, googleMapsLink?: string | null, id?: string | null, locationRecId?: string | null, name?: string | null, phone?: number | null, recId: string, schedule?: string | null, instagramLink?: string | null, telegramLink?: string | null, whatsAppLink?: string | null, media?: Array<{ __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null }> | null };

export type PartialPassFragment = { __typename?: 'Pass', activationDate?: any | null, active: boolean, autoBookingGroupRecId?: string | null, deactivationDate?: any | null, freezesRecIds: Array<string>, id?: string | null, kindRecId?: string | null, lessonsType: PassLessonsType, penaltiedLessonsRecIds: Array<string>, recId: string, refundRecId?: string | null, remainingBookingHours: number, remainingVisitHours: number, sickListsRecIds: Array<string>, status: PassStatus, statusConfirmationVisit?: PassConfirmationVisit | null, userId?: string | null, visitedLessonsRecIds: Array<string>, branchRecId?: string | null, kind?: { __typename?: 'PassKind', currency?: string | null, hours?: number | null, id?: string | null, name?: string | null, price?: number | null, recId: string, branchRecIds: Array<string>, category: PassCategory } | null };

export type LocationFragment = { __typename?: 'Location', lessonsRules?: string | null, schoolRules?: string | null, name?: string | null, recId: string };

export type UserProfileFragment = { __typename?: 'UserProfile', recId: string, id: string, name?: string | null, surname?: string | null, phone?: any | null, birthday?: any | null, dateRecognition?: any | null, dateLastVisit?: any | null, utmSource?: string | null, bonusBalance: number, totalSpent: number, administrator?: { __typename?: 'Administrator', recId: string, appName?: string | null, phone?: string | null, telegram?: string | null, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null } | null };

export type ReviewFragment = { __typename?: 'Review', recId: string, id?: string | null, dateReview?: any | null, score?: number | null, branch?: string | null, name?: string | null, phone?: string | null, review?: string | null, source?: Source | null };

export type AdministratorFragment = { __typename?: 'Administrator', recId: string, appName?: string | null, phone?: string | null, telegram?: string | null, avatar?: { __typename?: 'MediaFile', url: string, type: MediaFileType, thumbnail?: string | null, width?: number | null, height?: number | null } | null };

export type GetLinkQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetLinkQuery = { __typename?: 'Query', link: { __typename?: 'Links', recId: string, id: string, url: string } };

export type UpdatePassStatusConfirmationVisitMutationVariables = Exact<{
  recId: Scalars['String']['input'];
  status: PassConfirmationVisit;
}>;


export type UpdatePassStatusConfirmationVisitMutation = { __typename?: 'Mutation', updatePassStatusConfirmationVisit: { __typename?: 'Pass', recId: string, statusConfirmationVisit?: PassConfirmationVisit | null } };

export const GroupFragmentDoc = gql`
    fragment Group on Group {
  archived
  autoBookingPassesRecIds
  description
  id
  maxSeats
  name
  recId
  teacherRecId
  branchRecId
  direction
  level
  durationHours
  startTimeSeconds
  dayOfWeeks
}
    `;
export const MediaFileFragmentDoc = gql`
    fragment MediaFile on MediaFile {
  url
  type
  thumbnail
  width
  height
}
    `;
export const TeacherFragmentDoc = gql`
    fragment Teacher on Teacher {
  appName
  appTitle
  avatar {
    ...MediaFile
  }
  description
  id
  media {
    ...MediaFile
  }
  recId
  archived
}
    ${MediaFileFragmentDoc}`;
export const LessonFragmentDoc = gql`
    fragment Lesson on Lesson {
  bookingsRecIds
  waitingListRecIds
  direction
  durationHours
  endDateTime
  groupRecId
  id
  maxSeats
  penaltiesRecIds
  recId
  remainingSeats
  trialRemainingSeats
  startDateTime
  teacherRecId
  visitsRecIds
  noWriteOffRecIds
  passed
  type
  bookingAllowed
  trialBookingAllowed
}
    `;
export const BranchFragmentDoc = gql`
    fragment Branch on Branch {
  address
  archived
  contractUrl
  description
  googleMapsLink
  id
  locationRecId
  media {
    ...MediaFile
  }
  name
  phone
  recId
  schedule
  instagramLink
  telegramLink
  whatsAppLink
}
    ${MediaFileFragmentDoc}`;
export const PartialPassFragmentDoc = gql`
    fragment PartialPass on Pass {
  activationDate
  active
  autoBookingGroupRecId
  deactivationDate
  freezesRecIds
  id
  kind {
    currency
    hours
    id
    name
    price
    recId
    branchRecIds
    category
  }
  kindRecId
  lessonsType
  penaltiedLessonsRecIds
  recId
  refundRecId
  remainingBookingHours
  remainingVisitHours
  sickListsRecIds
  status
  statusConfirmationVisit
  userId
  visitedLessonsRecIds
  branchRecId
}
    `;
export const LocationFragmentDoc = gql`
    fragment Location on Location {
  lessonsRules
  schoolRules
  name
  recId
}
    `;
export const UserProfileFragmentDoc = gql`
    fragment UserProfile on UserProfile {
  recId
  id
  name
  surname
  phone
  birthday
  dateRecognition
  dateLastVisit
  utmSource
  bonusBalance
  totalSpent
  administrator {
    recId
    appName
    avatar {
      ...MediaFile
    }
    phone
    telegram
  }
}
    ${MediaFileFragmentDoc}`;
export const ReviewFragmentDoc = gql`
    fragment Review on Review {
  recId
  id
  dateReview
  score
  branch
  name
  phone
  review
  source
}
    `;
export const AdministratorFragmentDoc = gql`
    fragment Administrator on Administrator {
  recId
  appName
  avatar {
    ...MediaFile
  }
  phone
  telegram
}
    ${MediaFileFragmentDoc}`;
export const InitialDataDocument = gql`
    query InitialData($locationId: String!, $locationRecId: String!) {
  allUpcomingLessons(locationId: $locationId) {
    lessons {
      ...Lesson
    }
    groups {
      ...Group
    }
    teachers {
      ...Teacher
    }
  }
  branches(locationId: $locationId) {
    items {
      ...Branch
    }
  }
  location(recId: $locationRecId) {
    ...Location
  }
}
    ${LessonFragmentDoc}
${GroupFragmentDoc}
${TeacherFragmentDoc}
${BranchFragmentDoc}
${LocationFragmentDoc}`;

/**
 * __useInitialDataQuery__
 *
 * To run a query within a React component, call `useInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialDataQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      locationRecId: // value for 'locationRecId'
 *   },
 * });
 */
export function useInitialDataQuery(baseOptions: Apollo.QueryHookOptions<InitialDataQuery, InitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitialDataQuery, InitialDataQueryVariables>(InitialDataDocument, options);
      }
export function useInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitialDataQuery, InitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitialDataQuery, InitialDataQueryVariables>(InitialDataDocument, options);
        }
export type InitialDataQueryHookResult = ReturnType<typeof useInitialDataQuery>;
export type InitialDataLazyQueryHookResult = ReturnType<typeof useInitialDataLazyQuery>;
export type InitialDataQueryResult = Apollo.QueryResult<InitialDataQuery, InitialDataQueryVariables>;
export const AuthDataDocument = gql`
    query AuthData {
  profile {
    ...UserProfile
  }
  allPasses {
    items {
      ...PartialPass
    }
  }
  clubMembership {
    active
    expiresAt
  }
}
    ${UserProfileFragmentDoc}
${PartialPassFragmentDoc}`;

/**
 * __useAuthDataQuery__
 *
 * To run a query within a React component, call `useAuthDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthDataQuery(baseOptions?: Apollo.QueryHookOptions<AuthDataQuery, AuthDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthDataQuery, AuthDataQueryVariables>(AuthDataDocument, options);
      }
export function useAuthDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthDataQuery, AuthDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthDataQuery, AuthDataQueryVariables>(AuthDataDocument, options);
        }
export type AuthDataQueryHookResult = ReturnType<typeof useAuthDataQuery>;
export type AuthDataLazyQueryHookResult = ReturnType<typeof useAuthDataLazyQuery>;
export type AuthDataQueryResult = Apollo.QueryResult<AuthDataQuery, AuthDataQueryVariables>;
export const UserExistsDocument = gql`
    query UserExists($locationId: String!, $phone: PhoneNumber!) {
  userExists(locationId: $locationId, phone: $phone) {
    exists
    selfSignUpAllowed
  }
}
    `;

/**
 * __useUserExistsQuery__
 *
 * To run a query within a React component, call `useUserExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserExistsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useUserExistsQuery(baseOptions: Apollo.QueryHookOptions<UserExistsQuery, UserExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
      }
export function useUserExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserExistsQuery, UserExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
        }
export type UserExistsQueryHookResult = ReturnType<typeof useUserExistsQuery>;
export type UserExistsLazyQueryHookResult = ReturnType<typeof useUserExistsLazyQuery>;
export type UserExistsQueryResult = Apollo.QueryResult<UserExistsQuery, UserExistsQueryVariables>;
export const SendVerificationCodeDocument = gql`
    mutation SendVerificationCode($locationId: String!, $phone: PhoneNumber!, $signInAs: Boolean!) {
  sendVerificationCode(
    locationId: $locationId
    phone: $phone
    signInAs: $signInAs
  )
}
    `;

/**
 * __useSendVerificationCodeMutation__
 *
 * To run a mutation, you first call `useSendVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerificationCodeMutation, { data, loading, error }] = useSendVerificationCodeMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      phone: // value for 'phone'
 *      signInAs: // value for 'signInAs'
 *   },
 * });
 */
export function useSendVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendVerificationCodeMutation, SendVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVerificationCodeMutation, SendVerificationCodeMutationVariables>(SendVerificationCodeDocument, options);
      }
export type SendVerificationCodeMutationHookResult = ReturnType<typeof useSendVerificationCodeMutation>;
export type SendVerificationCodeMutationResult = Apollo.MutationResult<SendVerificationCodeMutation>;
export type SendVerificationCodeMutationOptions = Apollo.BaseMutationOptions<SendVerificationCodeMutation, SendVerificationCodeMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($code: String!, $locationId: String!, $locationRecId: String!, $name: NonEmptyString!, $phone: PhoneNumber!, $surname: NonEmptyString!, $utmSource: String) {
  auth: signUp(
    code: $code
    locationId: $locationId
    locationRecId: $locationRecId
    name: $name
    phone: $phone
    surname: $surname
    utmSource: $utmSource
  ) {
    profile {
      ...UserProfile
    }
    token
  }
}
    ${UserProfileFragmentDoc}`;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      code: // value for 'code'
 *      locationId: // value for 'locationId'
 *      locationRecId: // value for 'locationRecId'
 *      name: // value for 'name'
 *      phone: // value for 'phone'
 *      surname: // value for 'surname'
 *      utmSource: // value for 'utmSource'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const SignInDocument = gql`
    mutation SignIn($code: String!, $locationId: String!, $phone: PhoneNumber!) {
  auth: signIn(code: $code, locationId: $locationId, phone: $phone) {
    profile {
      ...UserProfile
    }
    token
  }
}
    ${UserProfileFragmentDoc}`;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      code: // value for 'code'
 *      locationId: // value for 'locationId'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const BalanceDocument = gql`
    query Balance {
  balance {
    amount
    debt
  }
}
    `;

/**
 * __useBalanceQuery__
 *
 * To run a query within a React component, call `useBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useBalanceQuery(baseOptions?: Apollo.QueryHookOptions<BalanceQuery, BalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BalanceQuery, BalanceQueryVariables>(BalanceDocument, options);
      }
export function useBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BalanceQuery, BalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BalanceQuery, BalanceQueryVariables>(BalanceDocument, options);
        }
export type BalanceQueryHookResult = ReturnType<typeof useBalanceQuery>;
export type BalanceLazyQueryHookResult = ReturnType<typeof useBalanceLazyQuery>;
export type BalanceQueryResult = Apollo.QueryResult<BalanceQuery, BalanceQueryVariables>;
export const EripTopUpDocument = gql`
    query EripTopUp {
  eripTopUp {
    accountNumber
    serviceCode
    fullAccountNumber
    qrCode
    instruction
    banks {
      name
      icon
      iosUrl
      androidUrl
      huaweiUrl
    }
  }
}
    `;

/**
 * __useEripTopUpQuery__
 *
 * To run a query within a React component, call `useEripTopUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useEripTopUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEripTopUpQuery({
 *   variables: {
 *   },
 * });
 */
export function useEripTopUpQuery(baseOptions?: Apollo.QueryHookOptions<EripTopUpQuery, EripTopUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EripTopUpQuery, EripTopUpQueryVariables>(EripTopUpDocument, options);
      }
export function useEripTopUpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EripTopUpQuery, EripTopUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EripTopUpQuery, EripTopUpQueryVariables>(EripTopUpDocument, options);
        }
export type EripTopUpQueryHookResult = ReturnType<typeof useEripTopUpQuery>;
export type EripTopUpLazyQueryHookResult = ReturnType<typeof useEripTopUpLazyQuery>;
export type EripTopUpQueryResult = Apollo.QueryResult<EripTopUpQuery, EripTopUpQueryVariables>;
export const CourseOfferDocument = gql`
    query CourseOffer($typeRecId: String!) {
  courseOffer(typeRecId: $typeRecId) {
    typeRecId
    title
    price
    currency
    placesLeft
    placesTotal
    bonusRatio
    bonusAvailable
    enrolled
    balance
    pendingEnrollment
  }
}
    `;

/**
 * __useCourseOfferQuery__
 *
 * To run a query within a React component, call `useCourseOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseOfferQuery({
 *   variables: {
 *      typeRecId: // value for 'typeRecId'
 *   },
 * });
 */
export function useCourseOfferQuery(baseOptions: Apollo.QueryHookOptions<CourseOfferQuery, CourseOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseOfferQuery, CourseOfferQueryVariables>(CourseOfferDocument, options);
      }
export function useCourseOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseOfferQuery, CourseOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseOfferQuery, CourseOfferQueryVariables>(CourseOfferDocument, options);
        }
export type CourseOfferQueryHookResult = ReturnType<typeof useCourseOfferQuery>;
export type CourseOfferLazyQueryHookResult = ReturnType<typeof useCourseOfferLazyQuery>;
export type CourseOfferQueryResult = Apollo.QueryResult<CourseOfferQuery, CourseOfferQueryVariables>;
export const RequestCourseEnrollmentDocument = gql`
    mutation RequestCourseEnrollment($typeRecId: String!, $useBonus: Boolean!) {
  requestCourseEnrollment(typeRecId: $typeRecId, useBonus: $useBonus)
}
    `;

/**
 * __useRequestCourseEnrollmentMutation__
 *
 * To run a mutation, you first call `useRequestCourseEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCourseEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCourseEnrollmentMutation, { data, loading, error }] = useRequestCourseEnrollmentMutation({
 *   variables: {
 *      typeRecId: // value for 'typeRecId'
 *      useBonus: // value for 'useBonus'
 *   },
 * });
 */
export function useRequestCourseEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<RequestCourseEnrollmentMutation, RequestCourseEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCourseEnrollmentMutation, RequestCourseEnrollmentMutationVariables>(RequestCourseEnrollmentDocument, options);
      }
export type RequestCourseEnrollmentMutationHookResult = ReturnType<typeof useRequestCourseEnrollmentMutation>;
export type RequestCourseEnrollmentMutationResult = Apollo.MutationResult<RequestCourseEnrollmentMutation>;
export type RequestCourseEnrollmentMutationOptions = Apollo.BaseMutationOptions<RequestCourseEnrollmentMutation, RequestCourseEnrollmentMutationVariables>;
export const CourseEripBillDocument = gql`
    mutation CourseEripBill($typeRecId: String!, $useBonus: Boolean!) {
  courseEripBill(typeRecId: $typeRecId, useBonus: $useBonus) {
    fullAccountNumber
    qrCode
    banks {
      name
      icon
      iosUrl
      androidUrl
      huaweiUrl
    }
  }
}
    `;

/**
 * __useCourseEripBillMutation__
 *
 * To run a mutation, you first call `useCourseEripBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseEripBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseEripBillMutation, { data, loading, error }] = useCourseEripBillMutation({
 *   variables: {
 *      typeRecId: // value for 'typeRecId'
 *      useBonus: // value for 'useBonus'
 *   },
 * });
 */
export function useCourseEripBillMutation(baseOptions?: Apollo.MutationHookOptions<CourseEripBillMutation, CourseEripBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseEripBillMutation, CourseEripBillMutationVariables>(CourseEripBillDocument, options);
      }
export type CourseEripBillMutationHookResult = ReturnType<typeof useCourseEripBillMutation>;
export type CourseEripBillMutationResult = Apollo.MutationResult<CourseEripBillMutation>;
export type CourseEripBillMutationOptions = Apollo.BaseMutationOptions<CourseEripBillMutation, CourseEripBillMutationVariables>;
export const GroupDocument = gql`
    query Group($recId: String!, $hasCached: Boolean!) {
  group(recId: $recId) @skip(if: $hasCached) {
    ...Group
    teacher {
      ...Teacher
    }
    branch {
      ...Branch
    }
  }
}
    ${GroupFragmentDoc}
${TeacherFragmentDoc}
${BranchFragmentDoc}`;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      recId: // value for 'recId'
 *      hasCached: // value for 'hasCached'
 *   },
 * });
 */
export function useGroupQuery(baseOptions: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
      }
export function useGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
        }
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupQueryResult = Apollo.QueryResult<GroupQuery, GroupQueryVariables>;
export const LessonDocument = gql`
    query Lesson($recId: String!, $hasCached: Boolean!) {
  lesson(recId: $recId) @skip(if: $hasCached) {
    ...Lesson
    group {
      ...Group
    }
    teacher {
      ...Teacher
    }
  }
}
    ${LessonFragmentDoc}
${GroupFragmentDoc}
${TeacherFragmentDoc}`;

/**
 * __useLessonQuery__
 *
 * To run a query within a React component, call `useLessonQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonQuery({
 *   variables: {
 *      recId: // value for 'recId'
 *      hasCached: // value for 'hasCached'
 *   },
 * });
 */
export function useLessonQuery(baseOptions: Apollo.QueryHookOptions<LessonQuery, LessonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LessonQuery, LessonQueryVariables>(LessonDocument, options);
      }
export function useLessonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonQuery, LessonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LessonQuery, LessonQueryVariables>(LessonDocument, options);
        }
export type LessonQueryHookResult = ReturnType<typeof useLessonQuery>;
export type LessonLazyQueryHookResult = ReturnType<typeof useLessonLazyQuery>;
export type LessonQueryResult = Apollo.QueryResult<LessonQuery, LessonQueryVariables>;
export const CancelLessonDocument = gql`
    mutation CancelLesson($lessonRecId: String!, $passRecId: String!) {
  cancelLessonBooking(lessonRecId: $lessonRecId, passRecId: $passRecId) {
    ...Lesson
  }
}
    ${LessonFragmentDoc}`;

/**
 * __useCancelLessonMutation__
 *
 * To run a mutation, you first call `useCancelLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelLessonMutation, { data, loading, error }] = useCancelLessonMutation({
 *   variables: {
 *      lessonRecId: // value for 'lessonRecId'
 *      passRecId: // value for 'passRecId'
 *   },
 * });
 */
export function useCancelLessonMutation(baseOptions?: Apollo.MutationHookOptions<CancelLessonMutation, CancelLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelLessonMutation, CancelLessonMutationVariables>(CancelLessonDocument, options);
      }
export type CancelLessonMutationHookResult = ReturnType<typeof useCancelLessonMutation>;
export type CancelLessonMutationResult = Apollo.MutationResult<CancelLessonMutation>;
export type CancelLessonMutationOptions = Apollo.BaseMutationOptions<CancelLessonMutation, CancelLessonMutationVariables>;
export const BookLessonDocument = gql`
    mutation BookLesson($lessonRecId: String!, $passRecId: String!) {
  createLessonBooking(lessonRecId: $lessonRecId, passRecId: $passRecId) {
    ...Lesson
  }
}
    ${LessonFragmentDoc}`;

/**
 * __useBookLessonMutation__
 *
 * To run a mutation, you first call `useBookLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookLessonMutation, { data, loading, error }] = useBookLessonMutation({
 *   variables: {
 *      lessonRecId: // value for 'lessonRecId'
 *      passRecId: // value for 'passRecId'
 *   },
 * });
 */
export function useBookLessonMutation(baseOptions?: Apollo.MutationHookOptions<BookLessonMutation, BookLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookLessonMutation, BookLessonMutationVariables>(BookLessonDocument, options);
      }
export type BookLessonMutationHookResult = ReturnType<typeof useBookLessonMutation>;
export type BookLessonMutationResult = Apollo.MutationResult<BookLessonMutation>;
export type BookLessonMutationOptions = Apollo.BaseMutationOptions<BookLessonMutation, BookLessonMutationVariables>;
export const AddUserToWaitingListDocument = gql`
    mutation addUserToWaitingList($lessonRecId: String!, $waitingListPassRecId: String!) {
  addUserToWaitingList(
    lessonRecId: $lessonRecId
    passRecId: $waitingListPassRecId
  ) {
    ...Lesson
  }
}
    ${LessonFragmentDoc}`;

/**
 * __useAddUserToWaitingListMutation__
 *
 * To run a mutation, you first call `useAddUserToWaitingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToWaitingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToWaitingListMutation, { data, loading, error }] = useAddUserToWaitingListMutation({
 *   variables: {
 *      lessonRecId: // value for 'lessonRecId'
 *      waitingListPassRecId: // value for 'waitingListPassRecId'
 *   },
 * });
 */
export function useAddUserToWaitingListMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToWaitingListMutation, AddUserToWaitingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToWaitingListMutation, AddUserToWaitingListMutationVariables>(AddUserToWaitingListDocument, options);
      }
export type AddUserToWaitingListMutationHookResult = ReturnType<typeof useAddUserToWaitingListMutation>;
export type AddUserToWaitingListMutationResult = Apollo.MutationResult<AddUserToWaitingListMutation>;
export type AddUserToWaitingListMutationOptions = Apollo.BaseMutationOptions<AddUserToWaitingListMutation, AddUserToWaitingListMutationVariables>;
export const RemoveUserFromWaitingListDocument = gql`
    mutation removeUserFromWaitingList($lessonRecId: String!, $waitingListPassRecId: String!) {
  removeUserFromWaitingList(
    lessonRecId: $lessonRecId
    passRecId: $waitingListPassRecId
  ) {
    ...Lesson
  }
}
    ${LessonFragmentDoc}`;

/**
 * __useRemoveUserFromWaitingListMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromWaitingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromWaitingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromWaitingListMutation, { data, loading, error }] = useRemoveUserFromWaitingListMutation({
 *   variables: {
 *      lessonRecId: // value for 'lessonRecId'
 *      waitingListPassRecId: // value for 'waitingListPassRecId'
 *   },
 * });
 */
export function useRemoveUserFromWaitingListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromWaitingListMutation, RemoveUserFromWaitingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromWaitingListMutation, RemoveUserFromWaitingListMutationVariables>(RemoveUserFromWaitingListDocument, options);
      }
export type RemoveUserFromWaitingListMutationHookResult = ReturnType<typeof useRemoveUserFromWaitingListMutation>;
export type RemoveUserFromWaitingListMutationResult = Apollo.MutationResult<RemoveUserFromWaitingListMutation>;
export type RemoveUserFromWaitingListMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromWaitingListMutation, RemoveUserFromWaitingListMutationVariables>;
export const PastLessonsDocument = gql`
    query PastLessons($offset: Int!, $pageSize: Int!) {
  pastUserLessons(offset: $offset, pageSize: $pageSize) {
    groups {
      ...Group
    }
    lessons {
      ...Lesson
    }
    teachers {
      ...Teacher
    }
  }
}
    ${GroupFragmentDoc}
${LessonFragmentDoc}
${TeacherFragmentDoc}`;

/**
 * __usePastLessonsQuery__
 *
 * To run a query within a React component, call `usePastLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastLessonsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function usePastLessonsQuery(baseOptions: Apollo.QueryHookOptions<PastLessonsQuery, PastLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PastLessonsQuery, PastLessonsQueryVariables>(PastLessonsDocument, options);
      }
export function usePastLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PastLessonsQuery, PastLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PastLessonsQuery, PastLessonsQueryVariables>(PastLessonsDocument, options);
        }
export type PastLessonsQueryHookResult = ReturnType<typeof usePastLessonsQuery>;
export type PastLessonsLazyQueryHookResult = ReturnType<typeof usePastLessonsLazyQuery>;
export type PastLessonsQueryResult = Apollo.QueryResult<PastLessonsQuery, PastLessonsQueryVariables>;
export const PassDocument = gql`
    query Pass($recId: String!) {
  pass(recId: $recId) {
    groups {
      ...Group
    }
    pass {
      ...PartialPass
      autoBookingGroup {
        ...Group
      }
      penaltiedLessons {
        ...Lesson
      }
      visitedLessons {
        ...Lesson
      }
      freezes {
        daysCount
        id
        price
        recId
        startDate
      }
      refund {
        amount
        date
        id
        recId
      }
      sickLists {
        daysCount
        endDate
        id
        photo
        recId
        startDate
      }
    }
    teachers {
      ...Teacher
    }
  }
}
    ${GroupFragmentDoc}
${PartialPassFragmentDoc}
${LessonFragmentDoc}
${TeacherFragmentDoc}`;

/**
 * __usePassQuery__
 *
 * To run a query within a React component, call `usePassQuery` and pass it any options that fit your needs.
 * When your component renders, `usePassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePassQuery({
 *   variables: {
 *      recId: // value for 'recId'
 *   },
 * });
 */
export function usePassQuery(baseOptions: Apollo.QueryHookOptions<PassQuery, PassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PassQuery, PassQueryVariables>(PassDocument, options);
      }
export function usePassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PassQuery, PassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PassQuery, PassQueryVariables>(PassDocument, options);
        }
export type PassQueryHookResult = ReturnType<typeof usePassQuery>;
export type PassLazyQueryHookResult = ReturnType<typeof usePassLazyQuery>;
export type PassQueryResult = Apollo.QueryResult<PassQuery, PassQueryVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($birthday: Date) {
  updateProfile(birthday: $birthday) {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      birthday: // value for 'birthday'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const TeacherDocument = gql`
    query Teacher($recId: String!, $hasCached: Boolean!) {
  teacher(recId: $recId) @skip(if: $hasCached) {
    ...Teacher
  }
}
    ${TeacherFragmentDoc}`;

/**
 * __useTeacherQuery__
 *
 * To run a query within a React component, call `useTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherQuery({
 *   variables: {
 *      recId: // value for 'recId'
 *      hasCached: // value for 'hasCached'
 *   },
 * });
 */
export function useTeacherQuery(baseOptions: Apollo.QueryHookOptions<TeacherQuery, TeacherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherQuery, TeacherQueryVariables>(TeacherDocument, options);
      }
export function useTeacherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherQuery, TeacherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherQuery, TeacherQueryVariables>(TeacherDocument, options);
        }
export type TeacherQueryHookResult = ReturnType<typeof useTeacherQuery>;
export type TeacherLazyQueryHookResult = ReturnType<typeof useTeacherLazyQuery>;
export type TeacherQueryResult = Apollo.QueryResult<TeacherQuery, TeacherQueryVariables>;
export const YearInReviewStatsDocument = gql`
    query YearInReviewStats {
  yearInReviewStats {
    totalLessons
    totalHours
    busiestMonth
    busiestMonthCount
    busiestMonthHours
    favoriteDirection
    favoriteDirectionCount
    favoriteTeacher {
      ...Teacher
    }
    favoriteTeacherCount
    favoriteAdministrator {
      ...Administrator
    }
    favoriteAdministratorCount
  }
}
    ${TeacherFragmentDoc}
${AdministratorFragmentDoc}`;

/**
 * __useYearInReviewStatsQuery__
 *
 * To run a query within a React component, call `useYearInReviewStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useYearInReviewStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYearInReviewStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useYearInReviewStatsQuery(baseOptions?: Apollo.QueryHookOptions<YearInReviewStatsQuery, YearInReviewStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YearInReviewStatsQuery, YearInReviewStatsQueryVariables>(YearInReviewStatsDocument, options);
      }
export function useYearInReviewStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YearInReviewStatsQuery, YearInReviewStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YearInReviewStatsQuery, YearInReviewStatsQueryVariables>(YearInReviewStatsDocument, options);
        }
export type YearInReviewStatsQueryHookResult = ReturnType<typeof useYearInReviewStatsQuery>;
export type YearInReviewStatsLazyQueryHookResult = ReturnType<typeof useYearInReviewStatsLazyQuery>;
export type YearInReviewStatsQueryResult = Apollo.QueryResult<YearInReviewStatsQuery, YearInReviewStatsQueryVariables>;
export const GetLinkDocument = gql`
    query GetLink($id: String!) {
  link(id: $id) {
    recId
    id
    url
  }
}
    `;

/**
 * __useGetLinkQuery__
 *
 * To run a query within a React component, call `useGetLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLinkQuery(baseOptions: Apollo.QueryHookOptions<GetLinkQuery, GetLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkQuery, GetLinkQueryVariables>(GetLinkDocument, options);
      }
export function useGetLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkQuery, GetLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkQuery, GetLinkQueryVariables>(GetLinkDocument, options);
        }
export type GetLinkQueryHookResult = ReturnType<typeof useGetLinkQuery>;
export type GetLinkLazyQueryHookResult = ReturnType<typeof useGetLinkLazyQuery>;
export type GetLinkQueryResult = Apollo.QueryResult<GetLinkQuery, GetLinkQueryVariables>;
export const UpdatePassStatusConfirmationVisitDocument = gql`
    mutation UpdatePassStatusConfirmationVisit($recId: String!, $status: PassConfirmationVisit!) {
  updatePassStatusConfirmationVisit(recId: $recId, status: $status) {
    recId
    statusConfirmationVisit
  }
}
    `;

/**
 * __useUpdatePassStatusConfirmationVisitMutation__
 *
 * To run a mutation, you first call `useUpdatePassStatusConfirmationVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePassStatusConfirmationVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePassStatusConfirmationVisitMutation, { data, loading, error }] = useUpdatePassStatusConfirmationVisitMutation({
 *   variables: {
 *      recId: // value for 'recId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdatePassStatusConfirmationVisitMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePassStatusConfirmationVisitMutation, UpdatePassStatusConfirmationVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePassStatusConfirmationVisitMutation, UpdatePassStatusConfirmationVisitMutationVariables>(UpdatePassStatusConfirmationVisitDocument, options);
      }
export type UpdatePassStatusConfirmationVisitMutationHookResult = ReturnType<typeof useUpdatePassStatusConfirmationVisitMutation>;
export type UpdatePassStatusConfirmationVisitMutationResult = Apollo.MutationResult<UpdatePassStatusConfirmationVisitMutation>;
export type UpdatePassStatusConfirmationVisitMutationOptions = Apollo.BaseMutationOptions<UpdatePassStatusConfirmationVisitMutation, UpdatePassStatusConfirmationVisitMutationVariables>;